import { Controller } from "stimulus"

export default class extends Controller {
  billingCodeLabel(code) {
    return {
      "90899": "90899 (Initial Evaluation)",
      "99214": "99214 (Renewal Visit)",
      "90792": "90792 (New Patient Visit)"
    }[code] || code
  }

  connect() {
    const toggle = this.element.querySelector("#reviewed-billing-code-toggle")
    const select = this.element.querySelector("#reviewed-billing-code-select")
    const selector = this.element.querySelector("#reviewed-billing-code-selector")
    const codeLabel = this.element.querySelector("#reviewed-billing-code")

    if (toggle && select && selector && codeLabel && !this.bound) {
      this.bound = true

      toggle.addEventListener("click", () => {
        selector.style.display = selector.style.display === "none" ? "block" : "none"
      })

      select.addEventListener("change", () => {
        codeLabel.textContent = this.billingCodeLabel(select.value)
      })
    }
  }

  submit(event) {
    const billable = event.currentTarget.dataset.billing // "true" / "false"
    const url = this.element.dataset.confirmBillingUrl
    const billingCode = this.element.querySelector("#reviewed-billing-code-select")?.value

    const u = new URL(url, window.location.origin)
    u.searchParams.set("billable", billable)
    if (billable === "true" && billingCode) {
      u.searchParams.set("billing_code_override", billingCode)
    }

    const token = document.querySelector('meta[name="csrf-token"]').content

    fetch(u.toString(), {
      method: "PUT",
      headers: {
        "X-CSRF-Token": token,
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "text/html"
      },
      credentials: "same-origin"
    }).then(() => {
      window.$(this.element).modal("hide")
      window.location.reload()
    })
  }
}
